import {useRef} from 'react';
import {fetchBookmarkAheadFeed} from '../endpoints/api';
import {useQuery} from '@tanstack/react-query';


// `paramsRef` is the trick that makes "static key + dynamic params" actually work: the
// queryFn captured by react-query's QueryObserver may be a closure from a stale render,
// so we read params from a ref that's updated synchronously every render. This guarantees
// the refetch (whenever it fires) uses the latest coords without changing the queryKey.
//
// 5-minute stale time keeps the page snappy on navigation without re-hitting the API.
export function useBookmarkAheadFeed(
  enabled = true,
  params?: {latitude?: number; longitude?: number},
) {
  const paramsRef = useRef(params);
  paramsRef.current = params;

  return useQuery(['bookmark-ahead-feed'], () => fetchBookmarkAheadFeed(paramsRef.current), {
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
